import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import PropTypes from 'prop-types';

import PaymentOptionsForm from './PaymentOptionsForm';

function PaymentOptions({
    clientSecret,
    email,
    paymentSetupSuccess,
    phone,
    setPaymentSetupSuccess,
    setPaymentTypeSelected,
    setSetupIntentID,
    stripePromise,
}) {
    if (paymentSetupSuccess) {
        return <div />;
    }

    return (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
            <PaymentOptionsForm
                paymentSetupSuccess={paymentSetupSuccess}
                setPaymentSetupSuccess={setPaymentSetupSuccess}
                setSetupIntentID={setSetupIntentID}
                clientSecret={clientSecret}
                setPaymentTypeSelected={setPaymentTypeSelected}
                email={email}
                phone={phone}
            />
        </Elements>
    );
}

PaymentOptions.propTypes = {
    clientSecret: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    paymentSetupSuccess: PropTypes.bool.isRequired,
    phone: PropTypes.string.isRequired,
    setPaymentSetupSuccess: PropTypes.func.isRequired,
    setPaymentTypeSelected: PropTypes.func.isRequired,
    setSetupIntentID: PropTypes.func.isRequired,
    stripePromise: PropTypes.instanceOf(Promise).isRequired,
};

export default PaymentOptions;
